import ccEcharts from '@/components/common/echarts/echarts-base.vue';

export default {
    name: 'pie-echarts',
    components: {ccEcharts},
    props: {
        id: {
            type: String,
            default: ''
        },
        data: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    watch: {
        data: {
            deep: true,
            handler: function (val) {
                this.echartsData = val;
                this.handleData();
            }
        }
    },
    data() {
        return {
            echartsData: this.data,
            options: {
                color: ['#3febdb', '#657798', '#407fff', '#ffc341', '#ff6946', '#786eff'],
                tooltip: {
                    show: true,
                    backgroundColor: 'transparent',
                    padding: 0,
                    formatter: function (params) {
                        const data = params.data;
                        if (data.name) {
                            let formatterVal = '<div class=\'fd-map-tooltip-02\'>';
                            formatterVal += `<p class='fd-map-title'>${data.name}</p>`;
                            formatterVal += `<p class='fd-map-text'><span>${data.value}<em>件</em></span></p>`;
                            return formatterVal;
                        }
                    }
                },
                legend: {
                    type: 'scroll',
                    icon: 'circle',
                    orient: 'vertical',
                    right: '5%',
                    align: 'left',
                    top: 'center',
                    textStyle: {
                        color: '#40444d',
                        fontSize: 16
                    },
                    itemGap: 30,
                    data: []
                },
                series: [{
                    type: 'pie',
                    z: 5,
                    center: ['202', '192'],
                    radius: ['77', '88'],
                    clockwise: true,
                    hoverAnimation: false,
                    avoidLabelOverlap: true,
                    itemStyle: {normal: {color: 'rgba(0,0,0,0.14)'}},
                    label: {show: false},
                    data: [100]
                }, {
                    type: 'pie',
                    z: 3,
                    center: ['202', '192'],
                    radius: ['77', '120'],
                    clockwise: true,
                    hoverAnimation: false,
                    avoidLabelOverlap: true,
                    itemStyle: {normal: {color: ''}},
                    label: {show: false},
                    data: []
                }]
            },
            total:0
        };
    },
    mounted() {
        this.handleData();
    },
    methods: {
        // 处理options的data
        handleData() {
            this.total = 0;
            this.echartsData.forEach(item => {
                this.total += item.value;
            });
            this.initOptions();
        },
        // 处理options
        initOptions() {
            const lengedData = [];
            this.echartsData.forEach(item => {
                lengedData.push(item.name);
            });
            this.options.series[1].data = this.echartsData;
            this.options.legend.data = lengedData;
        },
        clickEchart(param) {
            const select = param.name;
            this.total = 0;
            this.echartsData.forEach(item => {
                if (select === item.name) {
                    this.total += item.value;
                }
            });
        }

    }
};
